import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DialogService, DialogComponent } from 'ng2-bootstrap-modal';
import { AgentProfile } from '../../_models/agent.profile';
import { GATEWAYHISTORYLABELS, SHAREDCONSTANTS, SEARCHVIEWLABELS } from '../../_constants/constants';
import { RememberMeService } from '../../_services/rememberme.service';
import { DetailsComponent } from './../../details/details.component';

import { NotificationDialogComponent } from './../../notification/notification.dialog.component';

import { GatewayHistoryService } from '../../_services/gatewayhistory.service';

import { TranslatePipe } from '../../shared/translate/translate.pipe';
import { TranslateService } from '../../_services/translate.service';
import { LoaderService } from '../../_services/loader.service';

export interface GatewayHistoryDialogModel {
    subValue: string;
    opcoValue: string;
    agentprofile: AgentProfile;    
}

@Component({
    templateUrl: 'gateway-history.dialog.component.html',
    providers: [GatewayHistoryService, TranslatePipe]
})

export class GatewayHistoryComponent extends DialogComponent<GatewayHistoryDialogModel, string> implements GatewayHistoryDialogModel, OnInit {
      
    subValue: string;
    opcoValue: string;
    agentprofile: AgentProfile;
    gatewayhistroylabels = GATEWAYHISTORYLABELS;


      page: number = 1;
      totalItems: number;
      historyData: any = [];
      itemsPerPage : number = 10;
      isLoading:Boolean = false;
      offset:number = 0;
      recordStart:number = 0;
      recordEnd:number;

    constructor(private ds: DialogService, private cdRef:ChangeDetectorRef, private gatewayHistoryService: GatewayHistoryService, private translatePipe: TranslatePipe, private translateService: TranslateService, private loaderService: LoaderService) {
          super(ds);
    }

     ngOnInit(){         
         setTimeout(() => {
            this.getGatewayHistoryData(1);
        });         
      }


      ngAfterViewChecked()
      {        
       
        this.historyData = this.historyData;
        this.isLoading = this.isLoading;
        this.totalItems = this.totalItems;
        this.page = this.page;
      }


      getGatewayHistoryData = (event) => {

        this.loaderService.display(true);
      
        this.isLoading = true;

        this.offset = (event - 1) * this.itemsPerPage;
        
        
        this.gatewayHistoryService.getGatewayHistoryDataList(event, this.subValue, this.opcoValue, this.itemsPerPage, this.offset).subscribe(
          (data) => {      
              this.page = event; 
              this.historyData = data.items.sort((a: any, b: any) => new Date(b.timeOfRequest).getTime() - new Date(a.timeOfRequest).getTime()),
              this.totalItems = data.totalItems,
              this.isLoading = false,
              this.recordStart = (this.offset) + 1;
              this.recordEnd = (this.offset + this.itemsPerPage) - (this.itemsPerPage - parseInt(this.historyData.length));                                     

              this.loaderService.display(false);
          },
          (err) => {
              this.historyData = [];                              
              this.isLoading = false;
              this.loaderService.display(false); 


              if(err.json().internalCode && this.translateService.checkAPIErrorExistsByCode(err.json().internalCode)){
                  this.ds.addDialog(NotificationDialogComponent, {
                      success: false,
                      message: new TranslatePipe(this.translateService).transform(err.json().internalCode,'API_ERROR')                   
                  });
              } 
              else{
                  this.ds.addDialog(NotificationDialogComponent, {
                      success: false,
                      message: this.translatePipe.transform("COMMON_ERROR_MESSAGE",'SHAREDCONSTANTS')
                  });
              }             

              // if(err.json().code == "IDP_ERROR"){
              //       this.ds.addDialog(NotificationDialogComponent, {
              //           success: false,
              //           message: err.json().message
              //       });
              //   }else{
              //       this.ds.addDialog(NotificationDialogComponent, {
              //           success: false,
              //           message: this.translatePipe.transform("COMMON_ERROR_MESSAGE",'SHAREDCONSTANTS')
              //       });
              //   }
          },
          () => {
              if (this.historyData.length < 1) {
                  this.ds.addDialog(NotificationDialogComponent, {
                      success: false,
                      message: this.translatePipe.transform("NO_DATA_FOUND_ERROR",'SEARCHVIEWLABELS')
                  });
              }
          }
        );

        return event;
  }
}



// WEBPACK FOOTER //
// ./src/app/details/gateway-history/gateway-history.dialog.component.ts